export default __webpack_public_path__ + "static/media/uploader-medtronic-problem-1.80f72f59.png";